import { MissionToStaff } from '../../lib/types/models/mission-to-staff/mission-to-staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function markMissionIncomplete(missionToStaffId: number) {
  return restApiClient
    .url(constructApiUrl(API.missionToStaffs.markMissionIncomplete.url, { id: missionToStaffId }))
    .post<MissionToStaff>()
}
